import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Heading, AccordionItem } from '../../../../components/index'

import { customerDataApiService } from 'shared'
import { ProductType } from 'selfServicePortal/interfaces/i-api-support'
import { IFaqEntry } from 'shared/interfaces/i-api-faq'
import appConfig from 'app.config'
import i18next from 'i18next'
import SspContext from 'selfServicePortal/contexts/SspContext'

import './Faq.scss'

const Faq = () => {
	const { t } = useTranslation()
	const { productType } = useContext(SspContext)
	const [data, setData] = useState<IFaqEntry[] | undefined>([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState<Error>()

	useEffect(() => {
		async function getFaq() {
			setLoading(true)
			await customerDataApiService
				.getFAQ(
					appConfig.country,
					productType === 'Card'
						? ProductType.Card
						: productType === 'Deposit_Fixed'
						  ? ProductType.Deposit_Fixed
						  : ProductType.Deposit,
					i18next.language,
					t,
				)
				.then((data) => setData(data))
				.then(() => setLoading(false))
				.catch((error) => {
					console.log(error)
					setLoading(false)
					setError(error)
				})
		}
		getFaq()

		// eslint-disable-next-line
	}, [])

	return (
		<div className="fade-in faq container d-flex justify-content-center">
			<div className="fixed-width my-5">
				<Heading title={t('FAQTitle')} />
				<div className="accordion-container d-flex flex-column container">
					{error && (
						<div className="d-flex justify-content-center">
							{error.message}
						</div>
					)}
					{loading ? (
						<div id="circle-spinner"></div>
					) : (
						<>
							{data?.map((parent) => {
								return (
									<AccordionItem
										key={parent.rowKey}
										question={parent}
									/>
								)
							})}
						</>
					)}
				</div>
			</div>
		</div>
	)
}
export default Faq
